module.exports = __webpack_public_path__ + "assets/img/logo_sticpay.01f3fd8b.svg";